export const isDevMode = (): boolean => {
  return window.location.hostname === 'localhost';
};
